module.exports = __webpack_public_path__ + "bugs-roadmap-42e9d63c32caf03675e1b58b94ebc0cc.webp";